import { render, staticRenderFns } from "./DialogFiltroCliente.vue?vue&type=template&id=1807b598&"
import script from "./DialogFiltroCliente.vue?vue&type=script&lang=js&"
export * from "./DialogFiltroCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports